import React from "react";
import BuscadorApp from "../components/BuscadorApp";

/**
 * Página principal del widget de búsqueda AMX ClaroSports
 * 
 * @description Componente página que actúa como contenedor principal para la aplicación
 * de búsqueda. Implementa el patrón de composición delegando toda la lógica de negocio
 * al componente BuscadorApp, manteniendo una separación limpia entre responsabilidades
 * de página y lógica de aplicación.
 * 
 * **Patrón arquitectural:**
 * - Página contenedora simple sin lógica de negocio
 * - Delegación completa al componente de aplicación
 * - Separación clara entre routing y funcionalidad
 * - Base extensible para futuras mejoras de layout
 * 
 * **Principios de diseño aplicados:**
 * - Single Responsibility: Solo maneja el aspecto de "página"
 * - Composition over Inheritance: Usa BuscadorApp como building block
 * - Open/Closed: Extensible sin modificar la lógica existente
 * - Separation of Concerns: Página vs lógica de aplicación
 * 
 * @component
 * @returns {JSX.Element} Aplicación completa de búsqueda renderizada
 * 
 * @example
 * // Uso básico en sistema de routing
 * import { BrowserRouter, Routes, Route } from 'react-router-dom';
 * import HomePage from './pages/home';
 * 
 * function App() {
 *   return (
 *     <BrowserRouter>
 *       <Routes>
 *         <Route path="/" element={<HomePage />} />
 *       </Routes>
 *     </BrowserRouter>
 *   );
 * }
 * 
 * @example
 * // Extensión futura con layout y providers
 * export default function HomePage() {
 *   return (
 *     <PageLayout title="Búsqueda AMX">
 *       <BuscadorApp />
 *     </PageLayout>
 *   );
 * }
 * 
 * @example
 * // Testing del componente página
 * import { render, screen } from '@testing-library/react';
 * 
 * test('HomePage renders search application', () => {
 *   render(<HomePage />);
 *   expect(screen.getByRole('main')).toBeInTheDocument();
 * });
 * 
 * @since 1.1.0
 * @author Valeria Garcia
 * 
 * @see {@link ../components/BuscadorApp.js} Componente principal de la aplicación
 */
export default function HomePage() {
  return (
    <BuscadorApp />
  )
}